import { useState } from 'react';

const useCustomHook = () => {
  const [home, setHome] = useState(null);
  const [loading, setLoading] = useState(true);

  return { home, setHome , loading, setLoading };
};

export default useCustomHook;
